import { defineStore } from 'pinia'
import { api } from '@/lib/api'

export const useNotificationsStore = defineStore('notifications', {
  state: () => ({ list: [], unreadCount: 0 }),
  actions: {
    async fetch() {
      const res = await api('/api/notifications')
      if (!res.ok) return
      const data = await res.json()
      this.list = data.data
      this.unreadCount = data.unread_count
    },

    // Chega via ActionCable (notification.new).
    addRealtime(notification) {
      this.list = [notification, ...this.list].slice(0, 30)
      if (!notification.read) this.unreadCount += 1
    },

    async markRead(id) {
      const n = this.list.find(x => x.id === id)
      if (!n || n.read) return
      n.read = true
      this.unreadCount = Math.max(0, this.unreadCount - 1)
      await api(`/api/notifications/${id}/read`, { method: 'POST' })
    },

    async markAllRead() {
      this.list.forEach(n => {
        n.read = true
      })
      this.unreadCount = 0
      await api('/api/notifications/read_all', { method: 'POST' })
    },
  },
})
